/**
 * @description
 * Purchase credit note headers
 * 
 * @type       {array}
 */
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
        width: '5%',
    },
    {
        text: 'folio',
        value: 'credit_note_number',
    },
    {
        text: 'proveedor',
        value: 'pch_provider_business_name',
        width: '25%',
    },
    {
        text: 'factura',
        value: 'invoice_number',
    },
    {
        text: 'nota de debito',
        value: 'debit_note_number',
    },
    {
        text: 'tipo',
        value: 'type',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                small: true,
            },
        },
    },
    {
        text: 'cancelada',
        value: 'was_canceled',
        align: 'center',
        format: 'boolean',
    },
    {
        text: 'fecha pago',
        value: 'payment_date',
        align: 'right',
        format: 'date',
    },
    {
        text: 'fecha contable',
        value: 'accounting_date',
        align: 'right',
        format: 'date',
    },
    {
        text: 'fecha emision',
        value: 'emission_date',
        align: 'right',
        format: 'date',
    },
]
